import { composeEventHandlers } from '@opallabs/lambda'

export function handleKeyDown(
  inputRef: React.RefObject<HTMLInputElement>,
  onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>
): React.KeyboardEventHandler<HTMLDivElement> | undefined {
  return composeEventHandlers(
    onKeyDown,
    (e) => {
      if (e.key === ' ' || e.key === 'Enter') {
        inputRef.current?.click()
      }
    },
    { checkForDefaultPrevented: false }
  )
}

export function handleSelect(onSelect?: (e: Event) => void) {
  return composeEventHandlers(onSelect, (e) => e.preventDefault(), {
    checkForDefaultPrevented: false,
  })
}

export function handleClick(
  inputRef: React.RefObject<HTMLInputElement>,
  onClick?: React.MouseEventHandler<HTMLDivElement>
): React.MouseEventHandler<HTMLDivElement> | undefined {
  return composeEventHandlers(onClick, () => inputRef.current?.click(), {
    checkForDefaultPrevented: false,
  })
}
